/**
 * Gate a route on a role.
 *
 * Presentation, like everything else role-based in this application. It sends
 * someone to an explanation instead of a failure, and the backend still
 * refuses the work regardless of what renders.
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { hasAtLeast, type Role } from '../types/roles';

export function RequireRole({
  role,
  children,
}: {
  role: Role;
  children: React.ReactNode;
}) {
  const { session } = useAuth();
  if (!session || !hasAtLeast(session.roles, role)) {
    return <Navigate to="/not-authorized" replace />;
  }
  return <>{children}</>;
}
